import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import reglas1 from "../assets/avatares/reglas-1.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME3, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			stepKicker="Paso 2 · Reglas (1/3)"
			sidebarTitle="Reglas Dinámica I"
			loading={loading}
			onContinue={handleNext}
			video={reglas1}
		>
			<div className="start-game-rule-block">
				<h3>Trabajo en equipo</h3>
				<p>
					Formarán parte de un equipo que deberá superar distintos retos y
					pruebas clínicas de forma colaborativa.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Toma de decisiones acertadas</h3>
				<p>
					Para avanzar, el equipo deberá dar respuestas correctas en las
					decisiones clínicas.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Avance por etapas</h3>
				<p>
					Cada pantalla presentará un desafío distinto: preguntas de opción
					múltiple, ejercicios de selección, de arrastre y análisis de
					resultados.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Control del progreso</h3>
				<p>
					Una barra inferior les mostrará su ubicación dentro del juego y las
					actividades pendientes de resolver.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
